import { Text } from '@loadsmart/loadsmart-ui'

import { calculateRatePerDistance } from 'core/domain/LaneRate'
import { formatRate, formatRateSubmittedDateTime } from 'core/presenters/laneRatePresenter'

import { getRateValue, hasRatePerMile } from '../domain/Rate'
import { type SpotQuoteStatus } from '../domain/SpotQuoteStatus'
import { formatRateStatusLabel, getRateStatusColor } from '../presenter/spotQuotePresenter'

/**
 * Values with prefix `current` are the ones that the user typed on the input fields (Those will have values only when user is bidding on the quote)
 * Values with prefix `initial` are the ones that the user submitted for the quote
 */
export type SubmittedRateValueProps = {
  currentFlatRate?: number
  initialFlatRate: number
  initialPerMileRate: number
  mileage?: number
  submittedAt?: Date
  rateStatus: SpotQuoteStatus
}

export function SubmittedRateValue({
  currentFlatRate,
  initialFlatRate,
  initialPerMileRate,
  mileage,
  submittedAt,
  rateStatus,
}: SubmittedRateValueProps) {
  const currentRatePerMile =
    currentFlatRate && mileage ? calculateRatePerDistance(currentFlatRate, mileage) : undefined

  const flatRate = getRateValue(initialFlatRate, currentFlatRate)
  const ratePerMile = getRateValue(initialPerMileRate, currentRatePerMile)
  const calculatedRate = formatRate(flatRate, false, '$')
  const hasRPM = hasRatePerMile(Number(ratePerMile), mileage)
  const ratePerMileDisplay = hasRPM ? formatRate(ratePerMile, true, '$') : undefined
  const timeStamp = formatRateSubmittedDateTime(submittedAt)

  const rateStatusLabel = formatRateStatusLabel(
    rateStatus,
    calculatedRate,
    timeStamp,
    ratePerMileDisplay
  )
  const rateStatusColor = getRateStatusColor(rateStatus)

  return (
    <Text variant="body-bold" color={rateStatusColor}>
      {rateStatusLabel}
    </Text>
  )
}
